if (!customElements.get('estimated-delivery')) {
  customElements.define(
    'estimated-delivery',
    class EstimatedDelivery extends HTMLElement {
      connectedCallback() {
        const minimumDays = Number.parseInt(this.dataset.minimumDays, 10);
        const maximumDays = Number.parseInt(this.dataset.maximumDays, 10);
        const output = this.querySelector('[data-estimated-delivery-dates]');

        if (!output || !Number.isFinite(minimumDays) || !Number.isFinite(maximumDays)) return;

        const locale = this.dataset.locale?.toLowerCase().startsWith('fr') ? 'fr-FR' : 'en-GB';
        const startDate = this.addDays(minimumDays);
        const endDate = this.addDays(maximumDays);
        const formatter = new Intl.DateTimeFormat(locale, {
          day: 'numeric',
          month: 'short',
        });

        output.textContent = `${formatter.format(startDate)} – ${formatter.format(endDate)}`;
      }

      addDays(days) {
        const date = new Date();
        date.setHours(12, 0, 0, 0);
        date.setDate(date.getDate() + days);
        return date;
      }
    }
  );
}
